import { createFileRoute } from '@tanstack/react-router';

import { SectionDetail } from '@/features/projects/SectionDetail';

export const Route = createFileRoute('/_authenticated/projects/$projectSlug/sections/$sectionSlug')({
  component: function Page() {
    const { projectSlug, sectionSlug } = Route.useParams();
    return <SectionDetail projectSlug={projectSlug} sectionSlug={sectionSlug} />;
  },
});
